<cfp-modal-content class="audit-trail" (closeClicked)="close()">
  <ng-container modal-header>
    @if (isShowingSystemChanges) {
      <cfp-link (clicked)="back(false)"
        ><h4><cfp-icon [icon]="'chevron-left'" class="me-2" />Automatic system changes</h4></cfp-link
      >
    }
    @if (!isShowingSystemChanges) {
      <h4>{{ 'Audit trail' }}</h4>
    }
  </ng-container>
  <ng-container modal-body>
    @if (
      buildingSystemChangeLogItems && hasFieldNotApplicable(buildingSystemChangeLogItems) && isShowingSystemChanges
    ) {
      <cfp-alert icon="info-circle" [iconType]="'solid'" [alertStyle]="'light'">
        {{ 'auditTrail.notApplicable' | cfpTranslate }}
      </cfp-alert>
    }
    @if (isShowingSystemChanges) {
      <div @slideLeftRight (@slideLeftRight.done)="onDone($event, isShowingSystemChanges)" class="box">
        @for (
          buildingSystemChangeLogItem of buildingSystemChangeLogItems;
          track buildingSystemChangeLogItem;
          let last = $last
        ) {
          <cfp-audit-trail-item [building]="building" [logItem]="buildingSystemChangeLogItem" />
          @if (!last) {
            <hr aria-hidden="true" />
          }
        }
      </div>
    }
    @if (!isShowingSystemChanges) {
      <div @slideLeftRight class="box">
        @for (
          buildingChangeLogItem of buildingChangeLogItems;
          track buildingChangeLogItem;
          let index = $index;
          let last = $last
        ) {
          <cfp-audit-trail-item
            [building]="building"
            [ngClass]="'box-' + index"
            [logItem]="buildingChangeLogItem"
            (itemClicked)="onItemClicked($event, index)"
          />
          @if (!last) {
            <hr aria-hidden="true" />
          }
        }
        @if (!buildingChangeLogItems || buildingChangeLogItems.length === 0) {
          <cfp-alert [alertStyle]="'warning'" [iconType]="'solid'" icon="info-circle">{{
            'auditTrail.noRecords' | cfpTranslate
          }}</cfp-alert>
        }
      </div>
    }
  </ng-container>
  @if (!isShowingSystemChanges) {
    <ng-container modal-footer>
      <div class="row w-100">
        <div class="col d-flex justify-content-center mb-2 mb-md-0">
          <cfp-paging [total]="total" [limit]="limit" [offset]="offset" (offsetChange)="setOffset($event)" />
        </div>
        <div class="col-auto">
          <cfp-paging-limit [total]="total" [limit]="limit" (limitChange)="setLimit($event)" />
        </div>
      </div>
    </ng-container>
  }
</cfp-modal-content>
